import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FeatureFlagService } from 'feature-flag';
import { AgentDetails } from 'interfaces';

@Injectable({
  providedIn: 'root',
})
export class AgentService {
  private featureFlagService = inject(FeatureFlagService);
  private agentDetailsSubject = new BehaviorSubject<AgentDetails | null>(null);
  public agentDetails$ = this.agentDetailsSubject.asObservable();

  public setAgentDetails(agentDetails: AgentDetails | null): void {
    this.featureFlagService.setAttributeOverrides({ channel: agentDetails?.details?.channel });
    this.agentDetailsSubject.next(agentDetails);
  }
}
